import { createBrowserHistory } from 'history'

const history = createBrowserHistory({ basename: window.viewer.path })

export default history
